/*
 * @Author: your name
 * @Date: 2020-08-21 10:41:50
 * @LastEditTime: 2021-03-25 09:09:49
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /dmps-console-web/src/utils/http.js
 */
import axios from 'axios'
import vm from '../main'
import help from './help'

// const LOCALHOST = 'http://192.168.4.33:8010/'
const LOCALHOST = 'http://192.168.4.21:8849/'
// const LOCALHOST = 'http://imr.imrpress.tech:9100/api/'
// const TESTHOST = 'http://api.imrpress.tech:8849/'
const TESTHOST = 'http://imr.imrpress.tech:9100/api/'
const DEMOHOST = 'http://api.imrpress.tech:7849/'
const PREHOST = 'https://pre.propub.com/api/'
const HOST = 'https://api.propub.com/'
// const HOST = 'https://imr.propub.com/api/'

if (!localStorage.getItem('language')) {
  localStorage.setItem('language', 'en-US')
}

const CONTENTTYPE = 'application/x-www-form-urlencoded;charset=UTF-8'

axios.defaults.headers.post['Content-Type'] = CONTENTTYPE
axios.defaults.headers.get['Content-Type'] = CONTENTTYPE
axios.defaults.headers.put['Content-Type'] = CONTENTTYPE
axios.defaults.headers.delete['Content-Type'] = CONTENTTYPE

// 测试token
const TOKEN = ''
// const TOKEN = '25115cd3041e7199'
// 请求数组
const URLS = []
let timer = ''

/**
 * @description: axios拦截器
 * @param {Object}
 * @return {Promise}
 */
axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error.response) {
      // vm.$store._actions.updateLoading[0](false)
      if (error.response.status === 401) {
        // 返回 401 清除token信息并跳转到登录页面
        if (!window.location.href.includes('/access/login')) {
          if (!timer) {
            vm.$message.error({
              title: 'Error',
              content:
                vm.LANGUAGE[localStorage.getItem('language')].loginTimeOut
            })
          }
          timer = setTimeout(() => {
            clearTimeout(timer)
          }, 3000)
          localStorage.removeItem('token')
          vm.$router.push('/access/login')
        }
      } else if (
        error.response.status === 400 ||
        (error.response.status > 401 && error.response.status < 500)
      ) {
        if (error.request.responseType === 'blob') {
          var reader = new FileReader()
          reader.readAsText(error.response.data, 'utf-8')
          reader.onload = () => {
            vm.$message.error({
              title: 'Error',
              content: JSON.parse(reader.result).message
            })
          }
        } else {
          if (
            error.response.data.message &&
            error.response.data.code !== '9063'
          ) {
            vm.$message.error({
              title: 'Error',
              content: error.response.data.message
            })
          }
        }
        return Promise.reject(error.response.data)
      } else if (error.response.status >= 500) {
        vm.$message.error({
          title: 'Error',
          content: vm.LANGUAGE[localStorage.getItem('language')].serveError
        })
        return Promise.reject(error.response.data)
      }
    }
    return Promise.reject(error) // 返回接口返回的错误信息
  }
)

/**
 * @description:过滤请求失败的情况接口
 * @param {Object, boolen}
 * @return {Object}
 */
function warp(res) {
  // vm.$store._actions.updateLoading[0](false)
  // vm.$store._actions.updateContentLoad[0](false)
  if (res.data.code == 401) {
    vm.$message.error({
      title: 'Error',
      content: vm.LANGUAGE[localStorage.getItem('language')].loginTimeOut
    })
    localStorage.removeItem('token')
    vm.$router.push('/access/login')
  } else if (res.data.code !== '0000') {
    vm.$message.error({
      title: 'Error',
      content: res.data.message
    })
    throw res.data
  } else {
    return res.data.result
  }
}

/**
 * 请求前数据处理，请求头统一封装
 * @param {*} url data
 */
function beforeReq(url, data) {
  const URL = getUrl(url)
  if (!url.includes('/website') && !url.includes('dict/')) {
    // console.log(
    //   vm.$store.state.app.token &&
    //     localStorage.getItem('token') !== vm.$store.state.app.token &&
    //     !location.href.includes('/access/login')
    // )
    // console.log(location.href)
    if (
      vm.$store.state.app.token &&
      localStorage.getItem('token') !== vm.$store.state.app.token &&
      !location.href.includes('/access')
    ) {
      vm.$message.error({
        title: 'Error',
        content: 'Current login information has expired'
      })
      vm.$router.push('/access/login')
    }
    axios.defaults.headers.common['Authorization'] =
      localStorage.getItem('token') || TOKEN
  } else {
    delete axios.defaults.headers.common['Authorization']
  }
  // axios.defaults.headers.common['Accept-Language'] =
  //   localStorage.getItem('language') || 'en-US'
  const params = help.dataInit(data)
  return { URL, params }
}

/**
 * 用户登录接口
 * @param {username, password} data
 */
function login(api, data) {
  const { URL, params } = beforeReq(api, data)
  delete axios.defaults.headers.common['Authorization']
  return axios
    .post(URL, params)
    .then(res => {
      // 请求完成统一修改loading状态
      del_URLS(URL)
      // vm.$store._actions.updateLoading[0](false)
      if (res.status === 200) {
        if (res.data.code === '0000') {
          localStorage.setItem('token', 'Bearer ' + res.data.result.token)
          vm.$store._actions.updateToken[0]('Bearer ' + res.data.result.token)
          localStorage.setItem('refreshToken', res.data.result.refreshToken)
          localStorage.setItem('expire', res.data.result.expire)
          return res.data.result
        } else {
          vm.$message.error({ title: 'Error', content: res.data.message })
          return {
            errorMsg: res.data.message
          }
        }
      } else {
        return warp(res)
      }
    })
    .catch(err => {
      del_URLS(URL)
      return err
    })
}

/**
 * 用户注册接口
 * @param {*} data
 */
function register(api, data) {
  const { URL, params } = beforeReq(api, data)
  delete axios.defaults.headers.common['Authorization']
  return axios
    .post(URL, params)
    .then(res => {
      // 请求完成统一修改loading状态
      del_URLS(URL)
      // vm.$store._actions.updateLoading[0](false)
      return warp(res)
    })
    .catch(err => {
      del_URLS(URL)
      throw err
    })
}

// 流post
function octetPost(url, data = {}) {
  const { URL, params } = beforeReq(url, data)
  return axios({
    url: URL,
    method: 'post',
    data: params,
    responseType: 'blob' // 表明返回服务器返回的数据类型
  })
    .then(res => {
      del_URLS(URL)
      if (res.type !== 'application/json') {
        const fileName = res.headers['content-disposition'].split('=')[1]
        return {
          file: res.data,
          fileName
        }
      } else {
        return res
      }
    })
    .catch(err => {
      del_URLS(URL)
      return err
    })
}

// 流get
function octetget(url, data = {}) {
  const { URL, params } = beforeReq(url, data)
  return axios({
    url: URL,
    method: 'get',
    params,
    responseType: 'blob' // 表明返回服务器返回的数据类型
  })
    .then(res => {
      del_URLS(URL)
      if (res.type !== 'application/json') {
        const fileName = res.headers['content-disposition'].split('=')[1]
        return {
          file: res.data,
          fileName
        }
      } else {
        return res
      }
    })
    .catch(err => {
      del_URLS(URL)
      throw err
    })
}

// post方法
function post(url, data = {}) {
  const { URL, params } = beforeReq(url, data)
  return axios
    .post(URL, params)
    .then(res => {
      del_URLS(URL)
      return warp(res)
    })
    .catch(err => {
      del_URLS(URL)
      throw err
    })
}

// put方法
function put(url, data = {}) {
  const { URL, params } = beforeReq(url, data)
  return axios
    .put(URL, params)
    .then(res => {
      del_URLS(URL)
      return warp(res)
    })
    .catch(err => {
      del_URLS(URL)
      throw err
    })
}

// get方法
function get(url, data = {}) {
  const { URL, params } = beforeReq(url, data)
  return axios
    .get(URL, { params }, false)
    .then(res => {
      del_URLS(URL)
      return warp(res, false)
    })
    .catch(err => {
      del_URLS(URL)
      throw err
    })
}

// delete方法
function del(url, data = {}) {
  const { URL, params } = beforeReq(url, data)
  return axios
    .delete(URL, { params }, false)
    .then(res => {
      del_URLS(URL)
      return warp(res, false)
    })
    .catch(err => {
      del_URLS(URL)
      throw err
    })
}

let requestTimer
// 将请求添加至请求数组
function getUrl(api) {
  const URL = getUrlWarp(api)
  if (URLS.includes(URL) && !URL.includes('/sci/file/signal')) {
    if (!requestTimer) {
      requestTimer = setTimeout(() => {
        vm.$message.error({
          title: 'Error',
          content: 'In request, please do not repeat the operation'
        })
      }, 2000)
    }
    return
  }
  if (URL.includes('/sci/pdf_tools/base64/encode')) {
    return URL
  }
  URLS.push(URL)
  return URL
}

// 替换路由为对应项目路由
function getUrlWarp(api) {
  if (
    location.host.includes('192.168.5') ||
    location.host.includes('192.168.4.34') ||
    location.host.includes('102.168.4.21') ||
    location.host.includes('localhost')
  ) {
    return LOCALHOST + api
    // return TESTHOST + api
  } else if (
    location.host.includes('192.168.4.23') ||
    location.host.includes('imrpress.tech:9100')
  ) {
    return TESTHOST + api
  } else if (location.host.includes('imrpress.tech:8100')) {
    return DEMOHOST + api
  } else if (location.host.includes('imr.propub.com')) {
    return HOST + api
  } else if (location.host.includes('pre.propub.com')) {
    return PREHOST + api
  } else {
    return LOCALHOST + api
  }
  // return LOCALHOST + api
}

// 删除请求数组中消费完成的请求
function del_URLS(url) {
  const index = URLS.indexOf(url)
  if (index !== -1) {
    clearTimeout(requestTimer)
    requestTimer = ''
    URLS.splice(index, 1)
  }
}
const http = {
  register,
  login,
  post,
  get,
  put,
  del,
  octetPost,
  octetget
}

export default http
